import { render } from "./MyToken.vue?vue&type=template&id=3580146f&scoped=true"
import script from "./MyToken.vue?vue&type=script&lang=js"
export * from "./MyToken.vue?vue&type=script&lang=js"

import "@/assets/css/components/Mypage/mypage_pay.css?vue&type=style&index=0&id=3580146f&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3580146f"]])

export default __exports__